import size from "../sizes";
import image1 from "../../assets/images/materials/full-print/1.jpg";
import image21 from "../../assets/images/materials/full-print/2-1.jpg";
import image22 from "../../assets/images/materials/full-print/2-2.jpg";
import image23 from "../../assets/images/materials/full-print/2-3.jpg";
import image3 from "../../assets/images/materials/full-print/3.jpg";
import image4 from "../../assets/images/materials/full-print/4.jpg";
import image5 from "../../assets/images/materials/full-print/5.jpg";
import image6 from "../../assets/images/materials/full-print/6.jpg";
import image7 from "../../assets/images/materials/full-print/7.jpg";
import image8 from "../../assets/images/materials/full-print/8.jpg";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Стильная приталенная футболка из специальной высокотехнологичной двухслойной ткани. Внутри, приятный для тела хлопковый слой. Снаружи синтетика, которая позволят передать всю палитру цветов при печати. Рисунок получается насыщенный, долговечный и не ощущается на ощупь.</p><p>Печать осуществляется на ткани. После этого футболка сшивается. Это позволяет украсить всю футболку, вплоть до манжет и воротника.</p>`,
      images: [
        {
          source: image1,
          captionContent: {
            title: `Оригинальный и модный дизайн`,
            description: `Хотите выделиться и заслужить репутацию модника? Попробуйте 3D печать! Это принт на всей поверхности изделия — даже на рукавах. Такой дизайн выделит вас из толпы как человека с оригинальным вкусом и позволит воплотить любые творческие идеи в жизнь.`
          }
        },
        {
          source: image21,
          captionContent: {
            title: `3D-печать: как мы это делаем`,
            description: `В отличие от других видов печати, когда рисунок наносится на готовое изделие, 3D-одежда производится с нуля. Сначала мы раскладываем макет на лекала. Затем распечатываем их на рулоне ткани, из которой потом будем шить ваше изделие.`
          }
        },
        {
          source: image22,
          captionContent: {
            title: ``,
            description: `Ткань раскраивается вручную точно по лекалам для максимального совпадения рисунка...`
          }
        },
        {
          source: image23,
          captionContent: {
            title: ``,
            description: `… после чего аккуратно сшивается в несколько приемов на разных швейных машинках. В итоге вы получаете вещь с уникальным дизайном высокого качества, которая выглядит необычно и оригинально.`
          }
        },
        {
          source: image3,
          captionContent: {
            title: `Аккуратные швы`,
            description: `Мы с особой тщательностью подходим к качеству швов: от них зависит, как будет смотреться финальное изделие. У наших футболок все швы ровные, без перекосов и торчащих ниток.`
          }
        },
        {
          source: image4,
          captionContent: {
            title: `Нити в цвет принта`,
            description: `Нити, которые используются на лицевой стороне футболки, подбираем близко к цвету принта, чтобы максимально сохранить эффект 3D.`
          }
        },
        {
          source: image5,
          captionContent: {
            title: `Допускается несовпадение рисунка`,
            description: `В сложных принтах на стыках с рукавами возможно небольшое несовпадение макета на 1-2 см. Учитывайте это при выборе принта и дизайне рукавов.`
          }
        },
        {
          source: image6,
          captionContent: {
            title: `Высокое качество печати`,
            description: `Мы используем фирменные чернила и ткань высокого качества, поэтому цвета получаются максимально близкими к оригиналу. Готовая вещь смотрится качественно и дорого.`
          }
        },
        {
          source: image7,
          captionContent: {
            title: `Хлопок vs. Синтетика`,
            description: `При полной запечатке на хлопке и синтетике краска ведет себя по-разному. На хлопке цвета получаются чуть приглушенными, пастельными, а на синтетике — яркими и сочными.

            Кстати, синтетика синтетике рознь. Например, наша синтетика дышит, отлично носится и приятна к телу.`
          }
        },
        {
          source: image8,
          captionContent: {
            title: `Для всей семьи`,
            description: `Попробуйте напечатать одинаковые футболки для всей семьи — для взрослых и детей. Это отличная идея для семейной фотосессии или совместного отдыха! На фото - 3Д-футболки из хлопка.`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_woman_tee`],
      sizeInfo: `full_print_woman_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
